module.exports = __webpack_public_path__ + "static/media/drive.8ad900d8.svg";